import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import classes from "../../App.module.css";
import _ from "lodash";
import { connect } from "react-redux";
import "../../assets/css/customstyles.css";
import "../../assets/css/theme_blue.css";
import { Link, useHistory } from "react-router-dom";
import { MenuItem, Menu, Button } from "@dhis2/ui";
import DashboardHome from "../dashboard/DashboardHome";
import OfflineDb from "../../db";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import {
  faHome,
  faUserPlus,
  faSearch,
  faBullhorn,
  faFileAlt,
  faUsers,
  faFileInvoice,
  faEdit,
  faWifi,
  faCog,
  faSignOutAlt,
  faFileSignature,
  faUserFriends,
  faShareSquare,
  faPrescriptionBottle,
  faFlask,
  faPills,
  faMale,
  faRobot,
  faVideo,
  faEye,
  faFilePdf,
  faLanguage,
  faHdd,
  faExchangeAlt,
  faCalendar,
  faBook,
  faSitemap,
  faChalkboardTeacher,
  faDesktop,
  faClipboardList,
  faFile,
  faList,
} from "@fortawesome/free-solid-svg-icons";
import Grid from "@material-ui/core/Grid";
import { Configuration } from "../../assets/data/config";
import { apiServices } from "../../services/apiServices";
import { withStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import Disclaimer from "../../component/disclaimer/Disclaimer";
import swal from "@sweetalert/with-react";
import {
  setLoginUser,
  setLanguageList,
  setShowHeader,
} from "../../redux/actions/action";
import { useGlobalSpinnerActionsContext } from "../../context/GlobalSpinnerContext";

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#1a90ff",
  },
}))(LinearProgress);

function NewThemeHomePage(props) {
  const history = useHistory();
  const [ConfigurationFromServer, setConfigurationFromServer] = useState(null);
  const [orgDetails, setorgDetails] = useState(null);
  const relationshipTypeParams = Configuration.homepage.relationshipTypeParam;
  const DEGParams = Configuration.homepage.DEGParams;
  const OUGroupParams = Configuration.homepage.OUGroupParam;
  const programRuleVariableParam =
    Configuration.homepage.programRuleVariableParam;
  const dataSetParams = Configuration.homepage.dataSets;
  const OUStructureParams = Configuration.homepage.OUStrutureParams;
  const [reloadData, setReloadDataFlag] = React.useState(false);
  const [progress, setProgress] = React.useState(0);
  const [sessionUserBoValue, setSessionUserBoValue] = React.useState(null);
  const [userConsent, setUserConsent] = React.useState(null);
  const [userConsentAttributeIndex, setUserConsentAttributeIndex] =
    React.useState(null);
  const [programData, setProgramData] = React.useState(null);
  const { t, i18n } = useTranslation();
  const progressIncrement = progress + 10;
  const [registerdClient, setRegisterdClient] = React.useState(null);
  const [alertCount, setAlertCount] = React.useState(null);
  const [referralCasesCount, setReferralCasesCount] = React.useState(null);
  const [userrolename, setuserrolename] = React.useState(null);
  const [showSidebar, setShowSidebar] = useState(true);
  const [subSectionJson, setsubSectionJson] = useState({});
  const [allsubsectiondes, setallsubsectiondes] = useState([]);
  const [ncdsubsectionDeListItems, setncdsubsectionDeListItems] = useState([]);
  const [healthservicesubsection, sethealthservicesubsection] = useState([]);

  const dataSetValidationApi = Configuration.homepage.dataSetValidations;

  const PASSWORD_EXPIRY = Configuration.passwordExpiry;

  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const icons = {
    faHome,
    faUserPlus,
    faSearch,
    faBullhorn,
    faFileAlt,
    faUsers,
    faFileInvoice,
    faEdit,
    faWifi,
    faCog,
    faSignOutAlt,
    faFileSignature,
    faUserFriends,
    faShareSquare,
    faPrescriptionBottle,
    faFlask,
    faPills,
    faMale,
    faRobot,
    faVideo,
    faEye,
    faFilePdf,
    faLanguage,
    faHdd,
    faExchangeAlt,
    faCalendar,
    faBook,
    faSitemap,
    faChalkboardTeacher,
    faDesktop,
    faClipboardList,
    faFile,
    faList,
  };

  async function getUserBo() {
    let loginDetails = await OfflineDb.getDataFromPouchDB("loginDetails");
    setSessionUserBoValue(loginDetails.data);

    let configurations = await OfflineDb.getDataFromPouchDB("configurations");
    setConfigurationFromServer(configurations.data.configuration);

    let orgDetails = await OfflineDb.getDataFromPouchDB("orgDetails");
    setorgDetails(orgDetails.data);
  }

  useEffect(() => {
    if (localStorage.getItem("showCases")) {
      localStorage.removeItem("showCases");
    }
  }, []);

  function appUpdate() {
    swal({
      title: t("Application update"),
      text: t(
        "The current version of the application is no longer supported. Kindly upgrade the same!"
      ),
      icon: "warning",
      button:
        Configuration.mobileAppMode && Configuration.mobileAppMode == "debug"
          ? t("Ok")
          : t("Update"),
    }).then((res) => {
      if (
        Configuration.mobileAppMode &&
        Configuration.mobileAppMode == "debug"
      ) {
        appUpdate();
      } else {
        if (window.cordova && window.cordova.platformId == "ios") {
          window.open(Configuration.mobileAppiOSUrl, "_system");
        } else {
          window.open(Configuration.mobileAppDownloadUrl, "_system");
        }
      }
    });
  }

  // Version comparison function
  function compareVersions(v1, v2) {
    const v1Parts = v1.split(".").map(Number);
    const v2Parts = v2.split(".").map(Number);
    for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
      const part1 = v1Parts[i] || 0; // Default to 0 if segment is missing
      const part2 = v2Parts[i] || 0;
      if (part1 < part2) return -1; // v1 is less than v2
      if (part1 > part2) return 1; // v1 is greater than v2
    }
    return 0; // v1 is equal to v2
  }

  document.addEventListener("resume", () => {
    try {
      OfflineDb.getDataFromPouchDB("metaData").then((metaData) => {
        OfflineDb.getDataFromPouchDB("loginDetails").then((loginDetails) => {
          if (loginDetails.data != undefined) {
            const versionCheckParam =
              "metadata?fields=:owner,displayName&programs:filter=id:eq:" +
              loginDetails.data.programs[0] +
              "&programs:fields=:owner,unique,playName,attributeValues[:all,attribute[id,name,displayName]]";
            apiServices.getAPI(versionCheckParam).then((versionCheck) => {
              // console.log("versionCheck", versionCheck);
              if (
                metaData.data != undefined &&
                versionCheck.data != undefined &&
                Array.isArray(versionCheck.data.programs)
              ) {
                if (window.cordova) {
                  let result = _.filter(
                    versionCheck.data.programs[0].attributeValues,
                    ["attribute.name", "AppVersion"]
                  );
                  if (
                    result.length > 0 &&
                    result[0].value != Configuration.mobileAppVersion
                  ) {
                    appUpdate();
                  }
                }
              }
            });
          }
        });
      });
    } catch (e) {}
  });

  useEffect(() => {
    getUserBo();
    getsubSection();
    i18n.changeLanguage(localStorage.getItem("locale"));
  }, []);

  const checkPasswordExpiry = () => {
    OfflineDb.getDataFromPouchDB("loginDetails").then((loginDetails) => {
      console.log("loginDetails", loginDetails);

      const lastPasswordUpdated =
        loginDetails?.data?.userCredentials?.passwordLastUpdated;

      const now = new Date();
      const lastUpdatedDate = lastPasswordUpdated
        ? new Date(lastPasswordUpdated)
        : now; // fallback to now if missing

      // difference in days
      const diffMs = now - lastUpdatedDate;
      const diffDays = diffMs / (1000 * 60 * 60 * 24);

      console.log("diffDays", diffDays);
      console.log("PASSWORD_EXPIRY", PASSWORD_EXPIRY);
      if (Number(diffDays) > Number(PASSWORD_EXPIRY)) {
        props.setShowHeader(false);
      } else {
        // ✅ Allow login flow
        console.log("Password still valid, proceed with login");
      }
    });
  };

  useEffect(() => {
    if (progress === 100) {
      setReloadDataFlag(false);
      checkPasswordExpiry();
    }
  }, [progress]);

  useEffect(() => {
    if (sessionUserBoValue != null) {
      setuserrolename(
        sessionUserBoValue.userCredentials.userRoles[0]?.name ||
          sessionUserBoValue.userCredentials.userRoles[0]?.displayName
      );
      checkUserConsent();
    }
  }, [sessionUserBoValue]);

  useEffect(() => {
    OfflineDb.removeDataFromPouchDB("activeCaseDetails");
    OfflineDb.removeDataFromPouchDB("activeCaseFormData");
    OfflineDb.removeDataFromPouchDB("linkContactFlag");
    OfflineDb.setDataIntoPouchDB("transferFlag", { type: null });

    if (reloadData == true) {
      OfflineDb.getDataFromPouchDB("loginDetails").then((loginDetails) => {
        if (loginDetails.data != undefined) {
          //First Call
          apiServices
            .getAPI(
              "programs.json?fields=[id,displayFormName,publicAccess,organisationUnit[id,path,displayName]]&paging=false&filter=id:in:[" +
                loginDetails.data.programs.toString() +
                "]"
            )
            .then((programsDetails) => {
              //programBoDetails
              OfflineDb.getDataFromPouchDB("programBoDetails").then(
                (programBoDetails) => {
                  let metafinalurl =
                    "metadata?fields=:owner,displayName&programs:filter=id:eq:" +
                    programBoDetails.data.programuid +
                    "&programs:fields=:owner,displayName,description,attributeValues[:all,attribute[id,name,displayName,description,formName]],organisationUnits[id,path,displayName,description,level],dataEntryForm[:owner],programSections[id,name,displayName,formName,description,translations[*],renderType,program,sortOrder,lastUpdated,trackedEntityAttributes[id,name,displayName,formName,description,code,sortOrder,attributeValues[:all,attribute[id,name,displayName,description]],optionSet[id]]],notificationTemplates[:owner],programTrackedEntityAttributes[:owner,renderType,trackedEntityAttribute[id,displayName,formName,description,translations[*],valueType,unique,optionSet[id,options[id,code,displayName,description,translations[*],style]],attributeValues[:all,attribute[id,name,displayName,description]],domainType]],user[id,name],programStages[:owner,user[id,name],userAccesses,userGroupAccesses,displayName,description,attributeValues[:all,attribute[id,name,displayName,description]],programStageDataElements[:owner,renderType,unique,dataElement[id,displayName,description,formName,shortName,displayFormName,unique,valueType,fieldMask,translations[*],attributeValues[:all,attribute[id,name,displayName,description]],optionSet[id,options[id,code,displayName,description,translations[*],%20style]],domainType]],notificationTemplates[:owner,displayName,description],dataEntryForm[:owner],programStageSections[:owner,displayName,description,translations[*],dataElements[id,displayName,description]]]&dataElements:fields=id,displayName,formName,description,valueType,translations[*],optionSet&dataElements:filter=domainType:eq:TRACKER&trackedEntityAttributes:fields=id,displayName,formName,description,valueType,optionSet[id,options[id,code,displayName,description,style]],unique";

                  //Second call //metaDataParam
                  apiServices.getAPI(metafinalurl).then((metaData) => {
                    metaData.data.programs.map((programs) => {
                      const filterOU = programs.organisationUnits.find(
                        (array) =>
                          array.id ==
                          loginDetails.data["organisationUnits"][0].id
                      );

                      if (filterOU != undefined) {
                        metaData.data.programs = [programs];
                        loginDetails.data.programs = [
                          metaData.data.programs[0].id,
                        ];

                        OfflineDb.setDataIntoPouchDB(
                          "loginDetails",
                          loginDetails.data
                        );
                        setProgress(10);
                        OfflineDb.setDataIntoPouchDB("metaData", metaData.data);
                        setProgress(20);
                      } else {
                        OfflineDb.setDataIntoPouchDB("metaData", metaData.data);
                        setProgress(20);
                      }
                    });

                    //Third call
                    apiServices
                      .getAPI(relationshipTypeParams)
                      .then((response) => {
                        const relationshipTypes =
                          response.data.relationshipTypes;
                        if (relationshipTypes.length > 0) {
                          relationshipTypes.map((relationshipType) => {
                            if (
                              relationshipType.fromConstraint.program.id ==
                              loginDetails.data.programs[0]
                            ) {
                              OfflineDb.setDataIntoPouchDB(
                                "relationshipTypeId",
                                relationshipType.id
                              );
                              setProgress(30);
                            }
                          });
                        }

                        //Fourth Call
                        apiServices
                          .getAPI(DEGParams)
                          .then((dataElementGroup) => {
                            //sort dataElementGroup
                            dataElementGroup.data.dataElementGroups.map(
                              (dataElementGroups) => {
                                metaData.data.programs[0].programStages.map(
                                  (programStages) => {
                                    let findDataElementInStage =
                                      programStages.programStageDataElements.find(
                                        (x) =>
                                          x.dataElement.displayName ==
                                          dataElementGroups.displayName
                                      );
                                    if (findDataElementInStage) {
                                      dataElementGroups.dataElements.map(
                                        (dataElements) => {
                                          let findDataElementOptionsInStage =
                                            programStages.programStageDataElements.find(
                                              (x) =>
                                                x.dataElement.id ==
                                                dataElements.id
                                            );
                                          if (findDataElementOptionsInStage) {
                                            dataElements["sortOrder"] =
                                              findDataElementOptionsInStage.sortOrder;
                                          }
                                        }
                                      );
                                    }
                                  }
                                );
                                dataElementGroups.dataElements = _.orderBy(
                                  dataElementGroups.dataElements,
                                  ["sortOrder"],
                                  ["asc"]
                                );
                              }
                            );
                            OfflineDb.setDataIntoPouchDB(
                              "dataElementGroup",
                              dataElementGroup.data
                            );
                            setProgress(40);

                            //Fifth Call
                            apiServices
                              .getAPI(OUGroupParams)
                              .then((OUGroups) => {
                                OfflineDb.setDataIntoPouchDB(
                                  "organisationUnitGroups",
                                  OUGroups.data
                                );
                                setProgress(50);
                                const programRuleParam =
                                  "programRules?filter=program.id:eq:" +
                                  loginDetails.data.programs[0] +
                                  "&filter=name:ne:default&fields=id,displayName,condition,description,program[id],programStage[id],priority,programRuleActions[id,content,location,data,programRuleActionType,programStageSection[id],dataElement[id],trackedEntityAttribute[id],option[id],optionGroup[id],programIndicator[id],programStage[id]]&paging=false";

                                apiServices
                                  .getAPI(programRuleParam)
                                  .then((programRule) => {
                                    OfflineDb.setDataIntoPouchDB(
                                      "programRules",
                                      programRule.data
                                    );
                                    setProgress(60);

                                    apiServices
                                      .getAPI(
                                        programRuleVariableParam +
                                          "&filter=program.id:eq:" +
                                          loginDetails.data.programs[0]
                                      )
                                      .then((programRuleVariable) => {
                                        OfflineDb.setDataIntoPouchDB(
                                          "programRulesVariables",
                                          programRuleVariable.data
                                        );
                                        setProgress(70);
                                        apiServices
                                          .getAPI(dataSetParams)
                                          .then((dataSet) => {
                                            OfflineDb.setDataIntoPouchDB(
                                              "dataEntrySet",
                                              dataSet.data
                                            );
                                            setProgress(80);
                                            apiServices
                                              .getAPI(dataSetValidationApi)
                                              .then((dataSetRules) => {
                                                OfflineDb.setDataIntoPouchDB(
                                                  "datasetRules",
                                                  dataSetRules.data
                                                    ? dataSetRules.data
                                                        .validationRules
                                                      ? dataSetRules.data
                                                          .validationRules
                                                      : []
                                                    : []
                                                );
                                                setProgress(90);

                                                let ouAPI = OUStructureParams;
                                                if (
                                                  programBoDetails &&
                                                  programBoDetails.data &&
                                                  programBoDetails.data.orguid
                                                ) {
                                                  ouAPI =
                                                    "organisationUnits/" +
                                                    programBoDetails.data
                                                      .orguid +
                                                    "?includeDescendants=true&paging=false&fields=id,level,name,displayFormName,children,comment";
                                                }
                                                apiServices
                                                  .getAPI(ouAPI)
                                                  .then((OUStructureParams) => {
                                                    OfflineDb.setDataIntoPouchDB(
                                                      "OUStructureJSON",
                                                      OUStructureParams.data
                                                    );
                                                    setProgress(100);
                                                    setReloadDataFlag(false);
                                                  });
                                              });
                                          });
                                      });
                                  });
                              });
                          });
                      });
                  });
                }
              );
            });
        }
      });
    } else {
      if (reloadData == false) {
        OfflineDb.getDataFromPouchDB("dataElementGroup").then(
          (dataElementGroup) => {
            if (dataElementGroup.data == undefined) {
              if (!reloadData) {
                setReloadDataFlag(true);
              }
            }

            if (reloadData == false) {
              OfflineDb.getDataFromPouchDB("metaData").then((metaData) => {
                if (metaData.data == undefined) {
                  if (!reloadData) {
                    setReloadDataFlag(true);
                  }
                }
                //need for consent
                setProgramData(metaData.data);

                OfflineDb.getDataFromPouchDB("loginDetails").then(
                  (loginDetails) => {
                    if (loginDetails.data != undefined) {
                      // try {
                      //   if (
                      //     loginDetails.data.programs &&
                      //     loginDetails.data.programs.length == 1
                      //   ) {
                      //     getAlertCount(
                      //       loginDetails.data.programs[0],
                      //       loginDetails.data.organisationUnits[0].id
                      //     );
                      //   }
                      // } catch (e) { }
                      const versionCheckParam =
                        "metadata?fields=:owner,displayName&programs:filter=id:eq:" +
                        loginDetails.data.programs[0] +
                        "&programs:fields=:owner,unique,playName,attributeValues[:all,attribute[id,name,displayName]]";
                      apiServices
                        .getAPI(versionCheckParam)
                        .then((versionCheck) => {
                          //debugger
                          if (
                            metaData.data != undefined &&
                            versionCheck.data != undefined &&
                            Array.isArray(versionCheck.data.programs)
                          ) {
                            if (
                              versionCheck.data.programs[0].version !=
                              metaData.data.programs[0].version
                            ) {
                              if (!reloadData) {
                                setReloadDataFlag(true);
                              }
                            }
                            // logic for mobile app
                            if (window.cordova) {
                              let result = _.filter(
                                versionCheck.data.programs[0].attributeValues,
                                ["attribute.name", "AppVersion"]
                              );
                              if (
                                result.length > 0 &&
                                compareVersions(
                                  Configuration.mobileAppVersion,
                                  result[0].value
                                ) < 0
                              ) {
                                appUpdate();
                              }
                            }
                          }
                        });
                    }
                  }
                );

                if (reloadData == false) {
                  OfflineDb.getDataFromPouchDB("organisationUnitGroups").then(
                    (organisationUnitGroups) => {
                      if (organisationUnitGroups.data == undefined) {
                        if (!reloadData) {
                          setReloadDataFlag(true);
                        }
                      }

                      if (reloadData == false) {
                        OfflineDb.getDataFromPouchDB("programRules").then(
                          (programRules) => {
                            if (programRules.data == undefined) {
                              if (!reloadData) {
                                setReloadDataFlag(true);
                              }
                            }

                            if (reloadData == false) {
                              OfflineDb.getDataFromPouchDB("dataEntrySet").then(
                                (dataEntrySet) => {
                                  if (dataEntrySet.data == undefined) {
                                    if (!reloadData) {
                                      setReloadDataFlag(true);
                                    }
                                  }
                                }
                              );
                            }
                          }
                        );
                      }
                    }
                  );
                }
              });
            }
          }
        );
      }
    }
  }, [reloadData]);

  function getsubSection() {
    const getsubSectionURL = "dataStore/subSections/sections";
    setGlobalSpinner(true);
    apiServices
      .getAPI(getsubSectionURL)
      .then((subSections) => {
        setGlobalSpinner(false);
        setsubSectionJson(subSections.data);
        OfflineDb.setDataIntoPouchDB("subSectionJson", subSections.data);

        const allDeListItems = subSections.data["Client Profile"].flatMap(
          (item) => item.deList
        );
        setallsubsectiondes(allDeListItems);
        OfflineDb.setDataIntoPouchDB("allsubsectiondes", allDeListItems);

        const ncdDeListItems = subSections.data[
          "NCDs Screening, Treatment and Linkages"
        ].flatMap((item) => item.deList);
        setncdsubsectionDeListItems(ncdDeListItems);
        OfflineDb.setDataIntoPouchDB(
          "ncdsubsectionDeListItems",
          ncdDeListItems
        );

        const healthservicesubsection = subSections.data[
          "Health Service (Minimum Package)"
        ].flatMap((item) => item.deList);
        sethealthservicesubsection(healthservicesubsection);
        OfflineDb.setDataIntoPouchDB(
          "healthservicesubsection",
          healthservicesubsection
        );
      })
      .catch((err) => {
        setGlobalSpinner(false);
      });
  }

  function getAlertCount(programId, orgId) {
    let param = {
      param1: programId,
      param2: orgId,
    };
    apiServices
      .postAPI("common/getindicators/Get_customs_Clients_Alerts_counts", param)
      .then((result) => {
        if (result && result.data && result.data.data) {
          let regClient = _.find(result.data.data, {
            variablename: "ClientReg",
          });
          let alertsCount = _.find(result.data.data, {
            variablename: "Alert_counts",
          });
          let referralCasesCount = _.find(result.data.data, {
            variablename: "Referral",
          });
          if (regClient) {
            setRegisterdClient(regClient.numbercount);
          }
          if (alertsCount) {
            setAlertCount(alertsCount.numbercount);
          }
          if (referralCasesCount) {
            setReferralCasesCount(referralCasesCount.numbercount);
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  function checkUserConsent() {
    if (
      sessionUserBoValue != null &&
      sessionUserBoValue.attributeValues &&
      sessionUserBoValue.attributeValues.length > 0
    ) {
      sessionUserBoValue.attributeValues.map((val, indx) => {
        if (val.attribute.displayName === "IsConsent") {
          if (val.value == "true") {
            setUserConsent(true);
            setUserConsentAttributeIndex(indx);
          } else {
            setUserConsent(false);
            setUserConsentAttributeIndex(indx);
          }
        }
      });
    }
  }
  function setConset() {
    setUserConsent(true);
  }
  const onMenuClick = (menuName) => {
    if (menuName == "Logout") {
      OfflineDb.getAllEntities().then((res) => {
        if (res == undefined || res.total_rows == 0) {
          localStorage.clear();
          OfflineDb.deleteDatabse()
            .then((res) => {
              //(window.cordova) ? navigator.app.exitApp() : window.location.reload()
              props.setLoginUser(false);
            })
            .catch((err) => {
              //(window.cordova) ? navigator.app.exitApp() : window.location.reload()
              props.setLoginUser(false);
            });
        } else {
          swal({
            title: t("Offline data"),
            text: t("Offline records found, please sync data before logout"),
            icon: "warning",
            buttons: "Close",
          });
        }
      });
    }
    if (menuName == "My Clients") {
      localStorage.setItem("showCases", true);
      history.push("/layout/registration", { showCases: true });
    }
    if (menuName == "Users") {
      if (window.cordova && window.cordova.InAppBrowser) {
        window.cordova.InAppBrowser.open(
          Configuration.apiSurvey.key + "dhis-web-user/#/",
          "_system"
        );
      } else {
        window.open(Configuration.apiSurvey.key + "dhis-web-user/#/", "_blank");
      }
    }
    if (menuName == "Organisations") {
      if (window.cordova && window.cordova.InAppBrowser) {
        window.cordova.InAppBrowser.open(
          Configuration.apiSurvey.key +
            "dhis-web-maintenance/index.html#/list/organisationUnitSection/organisationUnit",
          "_system"
        );
      } else {
        window.open(
          Configuration.apiSurvey.key +
            "dhis-web-maintenance/index.html#/list/organisationUnitSection/organisationUnit",
          "_blank"
        );
      }
    }
  };

  function checkRoleAccess(menuItems, index) {
    let showMenu = true;
    const menuList = [
      "Alerts",
      "Search",
      "Line-List",
      "My Clients",
      "Appointments",
      "Add New Client",
      "Monthly Report",
      "Offline Client",
      "Activity Module",
      "Stock Management",
      "Deactivated User",
      "Mobile User Search",
      "Advanced Analytics",
      "Performance Report",
      "Mobile User Search",
      "Deactivated Clients",
    ];
    let role = menuItems.name;

    if (menuItems.name === "Appointments") {
      role = "Center Appointment";
    }

    if (menuItems.name === "Line-List") {
      role = "Line-list (Download)";
    }

    if (menuItems.name === "My Clients") {
      role = "Add New Client";
    }

    if (menuList.includes(menuItems.name)) {
      showMenu =
        ConfigurationFromServer.roleAccess[role][
          sessionUserBoValue.userCredentials.userRoles[0].name
        ];
    }

    if (menuItems.name === "Search") {
      showMenu =
        ConfigurationFromServer.roleAccess["Search"][
          sessionUserBoValue.userCredentials.userRoles[0].name
        ] ||
        ConfigurationFromServer.roleAccess["Add New Client"][
          sessionUserBoValue.userCredentials.userRoles[0].name
        ];
    }

    if (showMenu) {
      return (
        <Link
          className={classes.noDeco}
          to={menuItems.path}
          onClick={() => onMenuClick(menuItems.name)}
          key={index}
        >
          <MenuItem
            dataTest="dhis2-uicore-menuitem"
            icon={<FontAwesomeIcon icon={icons[menuItems.icon]} />}
            label={t(menuItems.name)}
          />
        </Link>
      );
    } else {
      return null;
    }
  }
  function renderNewStyleMenuitems() {
    return (
      <Menu className="">
        {ConfigurationFromServer &&
          ConfigurationFromServer.sidebar.menuItems.map((menuItems, index) => {
            // console.log(
            //   "ConfigurationFromServer",
            //   sessionUserBoValue.userCredentials.userRoles[0].name,
            //   ConfigurationFromServer.roleAccess,
            //   ConfigurationFromServer.sidebar.menuItems
            // );
            return menuItems.showMenu && !menuItems.userrole ? (
              menuItems.name == "Logout" ? (
                <Link
                  className={classes.noDeco}
                  to="#"
                  onClick={() => onMenuClick(menuItems.name)}
                  key={index}
                >
                  <MenuItem
                    dataTest="dhis2-uicore-menuitem"
                    icon={<FontAwesomeIcon icon={icons[menuItems.icon]} />}
                    label={t(menuItems.name)}
                  />
                </Link>
              ) : (
                checkRoleAccess(menuItems, index)
              )
            ) : null;
          })}
      </Menu>
    );
  }

  if (!props.showHeader) {
    swal({
      title: "Password Expired",
      text: `Your password is older than ${PASSWORD_EXPIRY} days. Please reset your password.`,
      icon: "warning",
      closeOnClickOutside: false, // ⛔ disable backdrop click
      closeOnEsc: false,
      buttons: {
        // cancel: {
        //   text: "Later",
        //   visible: true,
        //   className: "btn-cancel",
        // },
        confirm: {
          text: "Reset Now",
          visible: true,
          className: "btn-submit",
        },
      },
    }).then((willReset) => {
      console.log("willReset", willReset);
      if (willReset) {
        // redirect to reset flow
        history.push("/layout/settings");
      }
    });
  }
  return (
    <div className={classes.container}>
      {props.showHeader && (
        <main style={{ display: "flex", height: "100%", width: "100%" }}>
          <section
            className="mainsection pb-0 pT-55"
            style={{
              flexGrow: 1,
              padding: 0,
            }}
          >
            <Grid container spacing={0} className="d-none">
              <Grid item xs={12} sm={12} md={12} className="pos-relative">
                <div className="homeheaderdiv">
                  <h3 className="text-uppercase zero hide1">{t("Homepage")}</h3>
                  <div className="custom-shape-divider-top-1617788413">
                    <svg
                      data-name="Layer 1"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 1200 120"
                      preserveAspectRatio="none"
                    >
                      <path
                        d="M0,0V7.23C0,65.52,268.63,112.77,600,112.77S1200,65.52,1200,7.23V0Z"
                        className="shape-fill"
                      ></path>
                    </svg>
                  </div>
                </div>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              className="menulistingholder d-none"
            >
              {reloadData && progress != 100 ? (
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <p className="homepageappdesc">{t("Syncing data")}</p>
                    <BorderLinearProgress
                      variant="determinate"
                      value={progress}
                    />
                    <p className="homepageappdesc">
                      {" "}
                      {progress} % {t("completed")}{" "}
                    </p>
                  </Grid>
                </Grid>
              ) : !userConsent &&
                userConsent != null &&
                sessionUserBoValue != null &&
                sessionUserBoValue.attributeValues ? (
                <Grid item xs={12} sm={12} md={12} className="">
                  <div className="choose_alertdiv">
                    <Disclaimer
                      disclaimerContents={
                        programData != null
                          ? programData.programs[0].description
                          : "N/A"
                      }
                      sessionUserBoValue={sessionUserBoValue}
                      userConsentAttributeIndex={userConsentAttributeIndex}
                      userConsent={setConset}
                    />
                  </div>
                </Grid>
              ) : (
                // Add new Home page section
                <></>
              )}
            </Grid>
            <Grid container spacing={0} className="">
              {reloadData && progress != 100 ? (
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <p className="homepageappdesc">{t("Syncing data")}</p>
                    <BorderLinearProgress
                      variant="determinate"
                      value={progress}
                    />
                    <p className="homepageappdesc">
                      {" "}
                      {progress} % {t("completed")}{" "}
                    </p>
                    {/* </Grid> */}
                  </Grid>
                </Grid>
              ) : (
                <>
                  {showSidebar && (
                    <Grid item xs={2} sm={2} md={2} className="">
                      <div className="leftsidebar">
                        {/* {console.log("userrolename ", userrolename)} */}

                        {userrolename
                          ? renderNewStyleMenuitems()
                          : renderNewStyleMenuitems()}
                      </div>
                      <div className="version-tag web-version-tag">
                        {t("Version No")} : 1.0.0{" "}
                      </div>
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={showSidebar ? 10 : 12}
                    sm={showSidebar ? 10 : 12}
                    md={showSidebar ? 10 : 12}
                    className="rightsection"
                  >
                    <div className="" style={{ position: "relative" }}>
                      <span style={{ position: "absolute", left: "6px" }}>
                        <Button
                          small
                          type="button"
                          onClick={() => setShowSidebar(!showSidebar)}
                          className={
                            showSidebar
                              ? "myclientpanelopen"
                              : "myclientpanelclose"
                          }
                        >
                          {showSidebar ? (
                            <NavigateBeforeIcon />
                          ) : (
                            <NavigateNextIcon />
                          )}
                        </Button>
                      </span>
                      <DashboardHome />
                    </div>
                  </Grid>
                </>
              )}
            </Grid>
          </section>
        </main>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  const { storeState } = state;
  return { showHeader: storeState.showHeader };
};
//export default NewThemeHomePage;
export default connect(mapStateToProps, {
  setLoginUser,
  setLanguageList,
  setShowHeader,
})(NewThemeHomePage);
